import configuration from "../../Config";

//const Cryptr = require("cryptr");
//const cryptr = new Cryptr(configuration.KEY);

class Crypto {
	static Encrypt(name, value) {
		var j = JSON.stringify(value);
		//var c = cryptr.encrypt(j);
		sessionStorage.setItem(name, j);
	}

	static Decrypt(name) {
		var sess = sessionStorage.getItem(name);

		//var dec = cryptr.decrypt(sess);

		var par = JSON.parse(sess);

		return par;
	}
}
export default Crypto;
